module.exports = __webpack_public_path__ + "static/media/redOpacityMarker.d7fcf81d.svg";